import type { SetpointStepperWidget } from '../../../widgets';
import {
  BindingRow,
  NumberField,
  Row,
  Section,
  TextField,
  patcher,
  rangeError,
  stepError,
  type WidgetEditorProps,
} from '../fields';

/** Sollwert-Steller mit Plus und Minus. */
export function SetpointStepperEditor(
  { widget, plantId, onChange }: WidgetEditorProps<SetpointStepperWidget>,
) {
  const patch = patcher(widget, onChange);
  const range = rangeError(widget.min, widget.max);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Befehls-Datenpunkt"
          value={widget.commandPoint}
          plantId={plantId}
          filter={{ writable: true, valueType: 'number' }}
          onChange={(next) => patch({ commandPoint: next })}
        />
        <BindingRow
          label="Rückmelde-Datenpunkt"
          value={widget.feedbackPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ feedbackPoint: next })}
        />
      </Section>
      <Section title="Bereich">
        <Row>
          <NumberField
            label="Unten"
            value={widget.min}
            required
            error={range}
            onChange={(next) => patch({ min: next ?? 0 })}
          />
          <NumberField
            label="Oben"
            value={widget.max}
            required
            error={range ? ' ' : undefined}
            onChange={(next) => patch({ max: next ?? 0 })}
          />
          <NumberField
            label="Schrittweite"
            value={widget.step}
            required
            min={0}
            error={stepError(widget.step)}
            onChange={(next) => patch({ step: next ?? 0 })}
          />
        </Row>
        <Row>
          <TextField
            label="Einheit"
            value={widget.unit}
            placeholder="Grad C"
            onChange={(next) => patch({ unit: next })}
          />
          <NumberField
            label="Nachkommastellen"
            value={widget.decimals}
            min={0}
            max={4}
            integer
            onChange={(next) => patch({ decimals: next })}
          />
          <NumberField
            label="Wiederholrate"
            unit="ms"
            value={widget.repeatDelayMs}
            min={20}
            integer
            hint="Halten und laufen lassen. 250 ms ist ruhig, eine Skala von 0 bis 100 braucht eher 60 ms."
            onChange={(next) => patch({ repeatDelayMs: next })}
          />
        </Row>
      </Section>
    </>
  );
}
